import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import ElementCalendar from './MenuElementContent/ElementCalendar/ElementCalendar';
import ElementDashboard from './MenuElementContent/ElementDashboard/ElementDashboard';
import ElementClubs from './MenuElementContent/ElementClubs/ElementClubs';
import ElementBands from './MenuElementContent/ElementBands/ElementBands';
import ElementInfo from './MenuElementContent/ElementInfo/ElementInfo';
import MenuElementHOC from '../MenuElementHOC/MenuElementHOC';

import {
    GET_USER_ROUTE_TO_CALENDAR,
    GET_USER_ROUTE,
    ROUTE_DASHBOARD,
    GET_USER_ROUTE_TO_CLUBS,
    GET_USER_ROUTE_TO_BANDS,
    GET_USER_ROUTE_TO_USER_INFO
} from '../../../../config/RoutesConstants';

import { isLoggedInUserInLocalStorage } from '../../../../actions/UserActions';
import { getUserTypeNumber } from '../../../../client/Helper';

import './MenuElementContent.css';

class MenuElementContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: []
        };
    }

    componentDidMount() {
        this.updateItems(this.props);
    }

    componentDidUpdate(prevProps) {
        const userChanged = prevProps.user !== this.props.user;
        const selectedUserChanged = prevProps.selectedUser !== this.props.selectedUser;
        const locationChanged = prevProps.location.pathname !== this.props.location.pathname;

        if (userChanged || selectedUserChanged || locationChanged) {
            this.updateItems(this.props);
        }
    }

    updateItems = (props) => {
        const items = this.loadItems(props);
        this.setState({ items });
    }

    loadItems = (props) => {
        const { user, selectedUser, location } = props;
        const currentUser = isLoggedInUserInLocalStorage() && user && props.loggedUserDash ? user : selectedUser;

        if (!currentUser) {
            console.warn("No user data available yet.");
            return [];
        }

        const userType = getUserTypeNumber(currentUser);
        const pathname = location.pathname;

        const baseItems = [
            {
                key: 'dashboard',
                name: ElementDashboard,
                paths: [GET_USER_ROUTE(currentUser), ROUTE_DASHBOARD]
            },
            {
                key: 'calendar',
                name: ElementCalendar,
                paths: [GET_USER_ROUTE_TO_CALENDAR(currentUser)]
            },
            {
                key: 'info',
                name: ElementInfo,
                paths: [GET_USER_ROUTE_TO_USER_INFO(currentUser)]
            }
        ];

        const extraItems = [];

        if (isLoggedInUserInLocalStorage()) {
            if (userType === 1) {
                extraItems.push({
                    key: 'clubs',
                    name: ElementClubs,
                    paths: [GET_USER_ROUTE_TO_CLUBS(currentUser)]
                });
            } else if (userType === 2) {
                extraItems.push({
                    key: 'bands',
                    name: ElementBands,
                    paths: [GET_USER_ROUTE_TO_BANDS(currentUser)]
                });
            } else {
                extraItems.push(
                    {
                        key: 'bands',
                        name: ElementBands,
                        paths: [GET_USER_ROUTE_TO_BANDS(currentUser)]
                    },
                    {
                        key: 'clubs',
                        name: ElementClubs,
                        paths: [GET_USER_ROUTE_TO_CLUBS(currentUser)]
                    }
                );
            }
        }

        const allItems = [...baseItems.slice(0, 2), ...extraItems, baseItems[2]];

        return allItems.map(item => ({
            ...item,
            user: currentUser,
            active: item.paths.includes(pathname) ? 1 : 0
        }));
    }

    changeMenu = (index) => {
        this.setState((prevState) => {
            const updatedItems = prevState.items.map((item, i) => ({
                ...item,
                active: i === index ? 1 : 0
            }));
            return { items: updatedItems };
        });
    }

    render() {
        const { loggedUserDash } = this.props;
        const { items } = this.state;

        if (!items.length) return null;

        return (
            <div className={loggedUserDash ? "menu-element-content menu-element-content__logged-user" : "menu-element-content"}>
                {items.map((element, index) => {
                    const TagName = element.name;
                    return (
                        <MenuElementHOC key={element.key}>
                            <TagName
                                user={element.user}
                                active={element.active}
                                onClick={() => this.changeMenu(index)}
                                link={element.paths[0]}
                            />
                        </MenuElementHOC>
                    );
                })}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.userReducer.user,
        selectedUser: state.userReducer.selectedUser
    };
}

export default withRouter(connect(mapStateToProps)(MenuElementContent));
